export const AUTO_CLOSE_AFTER_SUCCESS_MS = 2500

export const RESET_PHASE_AFTER_CLOSE_MS = 200

export const SUPPRESS_OUTSIDE_AFTER_OPEN_MS = 300
